import { syncMissingRowsForOpenContracts } from './contractsSync';
import { CONTRACT_CHANGED } from '../../../services/contractVersion';
import { dubaiToday, isOpenStatus } from '../../../services/contractRules';
import {
    STAFF_SOURCE, contractNoOf, loadContractStaff, saveContractStaff, staffChangesOf, withStoredStaff,
} from '../../../services/contractStaff';

const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

/**
 * The contracts page's Auto-Sync on the contracts store (REACT_APP_CONTRACTS_V2 on). The page's rows carry Ejar's data
 * only, so each open contract's months are read from the store first (GET .../staff), the missing months are added
 * exactly as on Firestore (syncMissingRowsForOpenContracts, at the store's effective monthly rate) and saved on the
 * version they were read at, as 'Auto-Sync' - one contract at a time, 300 ms apart as before. A contract saved by
 * someone since is left as it is (its next load builds again), as on Firestore; any other refusal (a 403: the user
 * may not save contracts; the store down) stops the run, as any other error stopped it on Firestore.
 * Returns {read, saved, changedSince}.
 */
export const syncOpenMonthsToStore = async (rows, {
    load = loadContractStaff, save = saveContractStaff, today = dubaiToday(), pause = 300, wait = sleep, log,
} = {}) => {
    const out = { read: 0, saved: 0, changedSince: 0 };
    for (const row of (rows || []).filter(isOpenStatus)) {
        const no = contractNoOf(row);
        if (!no) continue;
        const view = await load(no);
        out.read += 1;
        const [update] = syncMissingRowsForOpenContracts([withStoredStaff(row, view)], today);
        if (!update) continue;
        try {
            await save(no, staffChangesOf(update.data), view.version, STAFF_SOURCE.autoSync);
            out.saved += 1;
        } catch (err) {
            // changed since it was read: its own months win; the next load generates again
            if (err.code !== CONTRACT_CHANGED) throw err;
            out.changedSince += 1;
            if (log) log.info(`[Auto-Sync] ${no} changed since it was read - not overwritten`);
        }
        await wait(pause);
    }
    return out;
};
